export interface LanguageOption {
  key: string;
  label: string;
  shortLabel: string;
  flag: string;
}

export const LANGUAGE_OPTIONS: readonly LanguageOption[] = [
  { key: "en", label: "English",     shortLabel: "EN",   flag: "🌐" },
  { key: "ja", label: "日本語",       shortLabel: "JA",   flag: "🇯🇵" },
  { key: "ko", label: "한국어",        shortLabel: "KO",   flag: "🇰🇷" },
  { key: "zh", label: "繁體中文",     shortLabel: "繁中", flag: "🇹🇼" },
  { key: "th", label: "ภาษาไทย",     shortLabel: "TH",   flag: "🇹🇭" },
  { key: "vi", label: "Tiếng Việt",  shortLabel: "VI",   flag: "🇻🇳" },
  { key: "es", label: "Español",     shortLabel: "ES",   flag: "🇪🇸" },
] as const;

export const DEFAULT_LANGUAGE_OPTION = LANGUAGE_OPTIONS[3]; // zh

export function getLanguageOption(lang: string | undefined): LanguageOption {
  return LANGUAGE_OPTIONS.find((opt) => opt.key === lang) ?? DEFAULT_LANGUAGE_OPTION;
}
